import { render } from "./HomeSpeakersSlider.vue?vue&type=template&id=e5ef5baa"
import script from "./HomeSpeakersSlider.vue?vue&type=script&lang=ts"
export * from "./HomeSpeakersSlider.vue?vue&type=script&lang=ts"

import "./HomeSpeakersSlider.vue?vue&type=style&index=0&id=e5ef5baa&lang=postcss"
script.render = render

export default script